import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import VueElementLoading from 'vue-element-loading';
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import common_helper from '../../../common_helper'

import {
	Validator
} from 'vee-validate'
export default {
	name: 'pushproduct',
	components: {
		Paginate,
		DatePicker,
		VueElementLoading
	},
	data: function() {
		return {
			clientarr : [],
			isRequired:true,
			showpoform: true,
			imagerelativepath: '',
			isLoading: false,
			iserror: false,
			disableButton: false,
			file: '',
			error_message: '',
			success_message: '',
			error_seen: false,
			success_seen: false,
			isError: '',
			isTempError: '',
			isUOMError: '',
			isdateError: '',
			dateerrors: '',
			istempError: '',
			createdbyEmail: '',
			listProductcategoryData: [],
			listsubProductcategoryData: [],
			listMerchantIdData: [],
			terms: false,
			tabIndex: 0,
			ismrptracked: 0,
			addproduct: {
				clientid: '',
				productid: '',
				merchantid: '',
				merchantname: '',
				maxtemp: '',
				isimgselected: 0,
				isimguploaded: 0,
				createdbyEmail: '',
				mintemp: '',
				productname: '',
				productcategoryname: '',
				subcategoryname: '',
				productsubcategory: '',
				productdescription: '',
				categoryname: '',
				producttype: '',
				brand: '',
				clientproductid: '',
				productimage: '',
				hsncode: '',
				hsnrate: '',
				shelflifeduration: '',
				shelflifeuom: '',
				primaryuom: '',
				secondaryuom: '',
				unitweight: '',
				unitweightuom: '',
				unitdimensonuom: '',
				unitlength: '',
				unitbreadth: '',
				unitheight: '',
				uomtemp: '',
				mfgcode: '',
				attribute1: '',
				expirycontrolled: '',
				lotcontrol: 0,
				//	isLotcontrol: 0,
				nocontrol: 0,
				isSerialcontrol: 0,
				//isexpirycontrol: 0,
				ishazardous: 0,
				isfragile: 0,
				isflammable: 0,
				isliquid: 0,
				serializecontrol: 0,
				mfgcontrolled: 0,
				istempsensitive: 0,
				controltype: '',
				stickername: '',
				eancode: '',
				subbrand: '',
				size: '',
				color: '',
				velocitycode: '',
				unitprice: '',
				unitheightuom: '',
				unitlengthuom: '',
				unitbreadthuom: '',
				productTax: 0,
				amazonProductId: '',
				flipkartProductId: '',
				filetype:'',
				fileupload:'',
				activemrp:'',
			},
			gstRateerror: '',
			mrperror: '',
			listClientData: [],
			user_type: '',
			client: '',
			clientid: '',
			showSelectClient: false,
			ClientErr: '',
			isshelflifeError:'',
			productUploadLabelUrl:'',
		 productUploadLabelUpload : '',
			productUploadLabelUrlsave : '',
      activemrpflag:false,
		}
	},
	created: function() {},
	// when a page loads,mounted() will be call
	mounted() {

		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY hh:mm:ss')

		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (this.clientid == 'undefined')
		{
			this.$alertify.error(this.$t('common.clientError'));
		}
		if (this.clientid != 'undefined')
		{
			this.getClientList()
			this.getMerchantList();
			this.getProductcategorylist();
			// this.getSubcategoryList();
			this.getActiveMrpFlag();
		}
		this.user_type = userdetail.utype;
		this.createdbyEmail = userdetail.email;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				// this.getClientList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.getMerchantList();
				this.getProductcategorylist();
				// this.getSubcategoryList();
				this.getActiveMrpFlag();
				break;

			case 'warehouse_user':
				this.showSelectClient = true;
				this.warehouseid = userdetail.warehouseid;
				// this.getClientList();
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}

	},
	methods: {

		getClientname(){
			this.client=localStorage.getItem("selectedClient")
			return this.clientarr[this.client]
		},

		checkmrp() {
			if (this.addproduct.mrp < 0) {
				this.mrperror = 'MRP field contain only positive value.'
			} else {
				this.mrperror = ''
			}


		},
		CheckGSTRate() {
			if (this.addproduct.hsnrate < 0) {
				this.gstRateerror = 'GST rate field contain only positive value.'
			} else {
				this.gstRateerror = ''
			}


		},

		getClientList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageNo = this.pageCount = 0;

			this.input = ({
				warehouseid: localStorage.getItem("selectedWarehouse"),
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listClientData = result.data.data;
					if (this.listClientData.length > 0) {
						for (let item in this.listClientData) {
							this.clientarr[this.listClientData[item].clientid] = this.listClientData[item].clientname;
					}
				} else {
					this.clientarr = [];
				}
				}, error => {
					console.error(error);
				});


		},
		findClientName(clientid) {
			for (let i = 0; i < this.listClientData.length; i++) {
			  if (this.listClientData.clientid === clientid) {
				console.log(this.listClientData[i].clientname+"fgdsjyigchsgd")
				return this.listClientData[i].clientname;
			  }
			}
			return null; // Return null if clientid not found
		  },
		// clientSelected() {
		// 	this.clientid = this.client;
		// 	if (this.clientid) {
		// 		this.getMerchantList();
		// 		this.getProductcategorylist();
		// 		this.getActiveMrpFlag();
		// 		// this.getSubcategoryList();
		// 		this.resetform();
		// 	}
		// },

		Checktemp() {
			if (Number(this.addproduct.maxtemp) < Number(this.addproduct.mintemp)) {
				this.isError = '1';
				this.Qtyerrors = 'Max Temp should be greater than Min  Temp';
			} else {
				this.isError = '';
				this.Qtyerrors = '';
			}
		},

		// Checkshelfduration() {
		// 	if (this.addproduct.shelflifeuom == null || this.addproduct.shelflifeduration == '') {
		// 		this.isUOMError = '1';
		// 		this.uomyerrors = ' Shelf Life Duration is required';
		// 		this.addproduct.shelflifeuom = '';
		// 	}
		// },

		lifeuom() {
			if (this.addproduct.shelflifeduration != '') {
				console.log(this.uomyerrors);
				this.isUOMError = '';
				this.uomyerrors = '';
			}
		},

		checkuom() {
			this.isUOMError = '';
			this.uomyerrors = '';
		},

		Checkdate() {
			var today = new Date();
			var expirydate = new Date(this.addproduct.expirydate);
			if (Date.parse(expirydate) >= Date.parse(today)) {
				this.isdateError = '';
				this.dateerrors = '';
			} else {
				this.isdateError = '1';
				this.dateerrors = 'Expiry date should be greater than or equal to today ';
			}
		},

		async getActiveMrpFlag(){
					var userToken = window.localStorage.getItem('userToken');
					var myStr = userToken.replace(/"/g, '');
					this.input = ({
						"clientid": localStorage.getItem("selectedClient"),
					});
				try {

						axios({
								method: 'POST',
								'url': apiUrl.api_url + 'checkActivemrpFlg',
								'data': this.input,
								headers: {
									'Authorization': 'Bearer ' + myStr,
								}
							})
							.then(result => {
							  if(result.data.data.data[0].value ==='yes'){
									this.activemrpflag = true;
								}else{
									this.activemrpflag = false;
								}
							}, error => {
								console.error(error);
							});

					} catch (err) {
						throw new Error(err);
					}
		},

		submitFile() {
			if (localStorage.getItem("selectedClient") == 'undefined') {
				this.ClientErr = "Client is required";
				return false;
			}

			var formData = new FormData();
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			formData.append('file', this.file);
			formData.append('clientid', this.clientid);
			axios.post(apiUrl.api_url + 'upload_file2',
					formData, {
						headers: {
							'Authorization': 'Bearer ' + myStr,
							'Content-Type': 'multipart/form-data'
						}
					})
				.then((response) => {
					this.imagerelativepath = response.data.path;
					this.isimguploaded = 1;
					if (response.status == true) {
						this.error_seen = false;
						this.success_seen = true;
						this.error_message = '';
						this.success_message = response.data.numrows + " items added successfully";
					} else {
						this.error_seen = true;
						this.success_seen = false;
						this.error_message = response.message;
						this.success_message = '';
					}
				})
				.catch(function() {
					;
					console.log('FAILURE!!');
				});
		},

		// handleFileUpload() {
		// 	if (this.clientid == '') {
		// 		this.ClientErr = "Client is required";
		// 		return false;
		// 	}
		//
		// 	this.isimgselected = 1;
		// 	this.isimguploaded = 0;
		// 	this.file = this.$refs.file.files[0];
		// 	this.submitFile();
		// },
		handleFileUpload() {
			this.file = this.$refs.file.files[0];
			let imageTypes = ['image/jpeg', 'image/png']
			let imageFormat = this.file.type
			let checkFormat = imageTypes.includes(imageFormat)
			if (!checkFormat) {
				this.file = null
				document.getElementById('file').value = null
				this.$alert("Invalid image format")
			}
		},
		async saveImage(imagetype, inputtype) {
			try {
				 if (!this.file && inputtype == 'file') {
					this.$alert("Select image")
					return false
				}
				if (inputtype == 'file') {
					console.log("=============553=========");
					var imgpath = document.getElementById('Image');
					if (!imgpath.value == "") {
						var img = imgpath.files[0].size;
						var imgsize = img / 1024;
						if (imgsize > 4000) {
							this.$alert("Image size cannot be greater than 4mb")
							document.getElementById('file').value = null
							this.file=null
							return false;
						}
					}
				}

				let imageString = ""
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');

					let reader = new FileReader()
					reader.readAsDataURL(this.file)
					imageString = await new Promise((resolve, reject) => {
						reader.onload = function() {
							this.base64String = reader.result.replace("", "")
							resolve(this.base64String)
						}
					})

				let inputpayload = {
					imagestring: imageString,
				}
				this.isLoading = true

		    let Result = await common_helper.getRestApiResponse('POST', 'addimageforOutsideProduct', inputpayload, this.$alertify)
					if (Result && !Result.errorDATA) {
							if (Result.data.status == true) {
								if (imagetype == 'Productimage') {
									this.productUploadLabelUpload = true
									this.productUploadLabelUrl = Result.data.presignurl
									this.productUploadLabelUrlsave = Result.data.dburl
								}
								this.$alertify.success(Result.data.data)
								this.isLoading = false

							} else {
								this.$alert(Result.data.msg)
								return false
							}
						}

			} catch (err) {
				console.log(err)
			}
		},
		myevent(productUploadLabelUrl) {
			if (productUploadLabelUrl != '') {
				this.isLoading = false
			}
		},
		linkClass(idx) {
			if (this.tabIndex === idx) {
				return ['bg-primary', 'text-light']
			} else {
				return ['bg-light', 'text-info']
			}
		},

		//to get productcategory name list
		getProductcategorylist() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				"clientid": localStorage.getItem("selectedClient"),
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getProductCategory',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listProductcategoryData = result.data.data;
				}, error => {
					console.error(error);
				});
		},

		// to get subcategory list
		getSubcategoryList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.addproduct.productsubcategory=''
			this.input = ({
				//	"offset": this.pageNo,
				//	"limit": this.pageLimit,
				"clientid": localStorage.getItem("selectedClient"),
				"productcategory": this.addproduct.productcategoryname
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getProductSubcategory',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listsubProductcategoryData = result.data.data;

				}, error => {
					console.error(error);
				})
		},

		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listMerchantIdData = result.data;
				}, error => {
					console.error(error);
				})
		},


		// save form fields in  database
		saveProduct() {

			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			if (this.clientid == 'undefined') {
				this.ClientErr = "Client is required";
				return false;
			}
			// if (this.addproduct.nocontrol == 0) {
			// 	this.addproduct.lotcontrol = 0
			// 	this.addproduct.expirycontrolled = 0
			// }
			// if (this.addproduct.nocontrol == 1) {
			// 	if (this.addproduct.lotcontrol == 0 && this.addproduct.expirycontrolled == 0) {
			// 		this.$alertify.error("Please select either lotcontrol or expirycontrolled");
			// 		return false;
			//
			// 	}
			// }
			if (this.addproduct.fileupload != null) {
				this.addUrl = this.addproduct.fileupload;
				//this.addUrl  = this.productUploadLabelUrlsave;
			}
			if (this.productUploadLabelUrlsave) {
             this.addUrl  = this.productUploadLabelUrlsave
			}


			if (this.addproduct.expirycontrolled == 1) {
				if(!this.addproduct.shelflifeduration){
					this.isshelflifeError = '1';
					this.Shelflifeduration = 'Shelf Life Duration field is required'
					return false;
				}else{
					this.isshelflifeError = '';

				}

      }else{
				this.isshelflifeError = '';
			}

			this.$validator.validateAll()
				.then((result) => {
					if (result) {
						var product2 = [];

						product2.push({
							'clientproductid': this.addproduct.clientproductid.trim(),
							'merchantid': this.addproduct.merchantname,
							'productname': this.addproduct.productname,
							'mrp': this.addproduct.mrp,
							'productdescription': this.addproduct.productdescription,
							'productcategory': this.addproduct.productcategoryname,
							'productsubcategory': this.addproduct.productsubcategory,
							'producttype': this.addproduct.producttype,
							'brand': this.addproduct.brand,
							'productimage': this.addUrl,
							'hsncode': this.addproduct.hsncode,
							'hsnrate': this.addproduct.hsnrate,
							'shelflifeduration': this.addproduct.shelflifeduration,
							'shelflifeuom': this.addproduct.shelflifeduration !== null ?'day':'',
							'primaryuom': this.addproduct.primaryuom,
							'secondaryuom': this.addproduct.secondaryuom,
							'unitweight': this.addproduct.unitweight,
							'unitweightuom': this.addproduct.unitweight !== null ? 'gm':'',
							'unitdimensonuom': this.addproduct.unitdimensonuom,
							'unitlength': this.addproduct.unitlength,
							'unitbreadth': this.addproduct.unitbreadth,
							'unitheight': this.addproduct.unitheight,
							'uomtemp': this.addproduct.uomtemp,
							'mintemp': this.addproduct.mintemp,
							'maxtemp': this.addproduct.maxtemp,
							'serializecontrol': Number(this.addproduct.serializecontrol),
							'mfgcontrolled': Number(this.addproduct.mfgcontrolled),
							'attribute1': this.addproduct.attribute1,
							'lotcontrol': Number(this.addproduct.lotcontrol),
							'expirycontrolled': Number(this.addproduct.expirycontrolled),
							'isserialcontrol': Number(this.addproduct.isSerialcontrol),
							'nocontrol': Number(this.addproduct.lotcontrol) === 1 || Number(this.addproduct.expirycontrolled) === 1 ? 1: 0,
							'ishazardous': Number(this.addproduct.ishazardous),
							'ismrptracked': Number(this.ismrptracked),
							'isfragile': Number(this.addproduct.isfragile),
							'isflammable': Number(this.addproduct.isflammable),
							'isliquid': Number(this.addproduct.isliquid),
							'mfgcode': this.addproduct.mfgcode,
							'istempsensitive': Number(this.addproduct.istempsensitive),
							'createdby': this.createdbyEmail,
							'stickername': this.addproduct.stickername,
							'eancode': this.addproduct.eancode != '' ?this.addproduct.eancode :this.addproduct.clientproductid.trim() ,
							'subbrand': this.addproduct.subbrand,
							'size': this.addproduct.size,
							'color': this.addproduct.color,
							'velocitycode': this.addproduct.velocitycode,
							'unitprice': Number(this.addproduct.unitprice),
							'unitheightuom': this.unitheight !== null ? 'cm' : '' ,
							'unitlengthuom': this.unitlength !== null ? 'cm':'',
							'unitbreadthuom': this.unitbreadth!== null ? 'cm':'',
							'producttax': Number(this.addproduct.productTax) ? this.addproduct.productTax : 0,
							'activemrp': Number(this.addproduct.activemrp),
						})

						if (this.isimgselected == 1 && this.isimguploaded == 0) {
   						alert('please wait image is uploading');
							return false;
						}
						if (this.clientid=='undefined')
						{
							this.$alertify.error(this.$t('common.clientError'));
							return false
						}
						this.isLoading = true;
						axios.post(apiUrl.api_url + 'pushProduct', {
								'products': product2,
								'clientid': this.clientid,
							}, {
								headers: {
									'Content-Type': 'application/json',
									'Authorization': 'Bearer ' + myStr
								}
							})
							.then((response) => {
								this.isLoading = false;
								console.log(response.data);
								if (response.data.statusCode == 200) {
									this.$alertify.success("Product Created Successfully");
									this.iserror = false;
									this.resetform();
								} else if(response.data.statusCode == -1){
									this.$alertify.error(response.data.duplicateProductsMsg);
									this.resetform();
								} else  {
									this.$alertify.error(response.data.data.message);
									this.resetform();
								}
							})
							.catch((httpException) => {
								console.error('exception is:::::::::', httpException)
							})
					} else {
						console.log('Error ');
						return false;
					}
				});
		},

		// To reset form
		resetform() {
			var self = this;
			this.isLoading = false;
			this.tabIndex = 0;
			if (document.getElementById("Image")) {
				document.getElementById("Image").value = "";
			}
			this.file = '';
			Object.keys(this.addproduct)
				.forEach(function(key, index) {
					if (key.startsWith("is")) {
						self.addproduct[key] = 0;
					} else {
						self.addproduct[key] = '';
					}
				});
			this.showpoform = false;
			this.$nextTick(() => {
				this.showpoform = true;
				this.Checktemp();
			});
		},

		//validate all form fields on onsubmit()
		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (this.errors.items.length > 0) {
					return false;
				}
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},

		validateTab() {
			this.$validator.validateAll('tab1').then((result) => {
				if (result) {
					this.tabIndex = 1;
				} else {
					this.tabIndex = 0;
					return false;
				}
			}).catch(() => {
				this.tabIndex = 0
				console.log('errors exist', this.errors)
			});
		},

		clientChange() {

		},

		validateTemp() {
			this.$validator.validateAll('temp').then((result) => {
				if (this.errors.items.length > 0) {
					return false;
				}
			}).catch(() => {
				this.tabIndex = 0
				console.log('errors exist', this.errors)
			});
		},

		temsensitiveChange() {
			if (this.addproduct.istempsensitive == 0) {
				this.addproduct.mintemp = '',
					this.addproduct.maxtemp = '',
					this.addproduct.uomtemp = '',
					this.addproduct.istempsensitive = 0
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/pushProduct/pushProduct.component.js